import { render, staticRenderFns } from "./indexView.vue?vue&type=template&id=a912f48e&scoped=true"
import script from "./indexView.vue?vue&type=script&lang=js"
export * from "./indexView.vue?vue&type=script&lang=js"
import style0 from "./indexView.vue?vue&type=style&index=0&id=a912f48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a912f48e",
  null
  
)

export default component.exports